import React from 'react';
import cn from 'classnames';
import Svg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import { logoDealerImage } from '../../images';
import StyledLogo from './Logo.style';

const Logo = ({ theme }) => (
  <StyledLogo
    to={'/'}
    data-testid="logo-link"
    className={cn(
      'logo',
      theme ? theme.map(css => `logo--${css}`).join(' ') : ''
    )}
  >
    <Svg src={logoDealerImage} />
  </StyledLogo>
);

Logo.propTypes = {
  theme: PropTypes.array
};
export default Logo;
